/**
 * Hvor lenge filterskjemaene venter etter siste tastetrykk før lista
 * filtreres. ra-core bruker 500 ms som standard, noe som føles tregt i et
 * søkefelt. 250 ms svarer raskt uten å sende én spørring per tastetrykk.
 */
export const FILTER_DEBOUNCE = 250;
